module.exports = __webpack_public_path__ + "img/RV_ambnljztfHxfXc7xnbjA6QKw.3e1e9777.png";